<div class="lds-ellipsis" role="status">
  <div></div><div></div><div></div><div></div>
  <span class="sr-only">Loading...</span>
</div>
